export default __webpack_public_path__ + "static/media/popupTransitionPremium.af5d75a4.m4v";